import React from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router
} from "react-router-dom"

import './master.css';
import App from './App.jsx';

ReactDOM.render(
    <React.StrictMode>
        <Router basename="./">
            <App />
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
);
